import {
  DataGridPro,
  useGridApiRef,
  GridColumns,
  GridRowsProp,
  GridInitialState,
  GridEventListener,
  GridEvents,
  GridRowParams,
  GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
  GridSelectionModel,
  GridRowIdGetter,
} from '@mui/x-data-grid-pro'
import { useCallback } from 'react'
import {
  Toolbar,
  Pagination,
  NoRowsOverlay,
  LoadingOverlay,
  ToolbarProps,
  DetailPanelToggle,
} from './components'
import { Box, SxProps } from '@mui/material'
import { makeStyles } from '@mui/styles'

type DataTableProps = {
  loading: boolean
  rows: GridRowsProp
  columns: GridColumns
  toolBarProps: ToolbarProps
  initialState?: GridInitialState
  onRowClick?: GridEventListener<GridEvents.rowClick>
  onRowDoubleClick?: GridEventListener<GridEvents.rowDoubleClick>
  form?: any
  detailPanelHeight: number
  size?: number
  isDetails?: boolean
  searchSex?: boolean
  isScrollable?: boolean
  checkboxSelection?: boolean
  onSelectionModelChange?: (selectionModel: GridSelectionModel) => void
  getRowId?: GridRowIdGetter
  disableMultipleSelection?: boolean
  sx?: SxProps
}

const useStyles = makeStyles({
  root: {
    '& .css-1pans1z-MuiDataGrid-virtualScroller': {
      overflowX: 'hidden !important',
    },
  },
})

export function DataTable({ form: Form, ...props }: DataTableProps) {
  const apiRef = useGridApiRef()
  const classes = useStyles()
  const getDetailPanelHeight = useCallback(
    () => props.detailPanelHeight,
    [props.detailPanelHeight],
  )
  const getDetailPanelContent = useCallback(
    ({ row }: GridRowParams<any>) => (
      <Box sx={{ p: '10px', background: '#fff' }}>
        <Form row={row} />
      </Box>
    ),
    [Form],
  )

  const columns = Form
    ? [
        {
          ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
          renderCell: (params) => (
            <DetailPanelToggle id={params.id} value={params.value} />
          ),
        },
        ...props.columns,
      ]
    : props.columns
  return (
    <DataGridPro
      {...props}
      className={!props.isScrollable ? classes.root : ''}
      columns={columns}
      apiRef={apiRef}
      pageSize={5}
      rowHeight={props.size || 60}
      rowsPerPageOptions={[5]}
      disableColumnMenu
      disableMultipleSelection={props.disableMultipleSelection}
      disableSelectionOnClick
      components={{
        Toolbar,
        Pagination,
        NoRowsOverlay,
        LoadingOverlay,
      }}
      componentsProps={{
        toolbar: props.toolBarProps,
        row: {
          style: { cursor: 'pointer' },
        },
      }}
      onRowDoubleClick={props.onRowDoubleClick}
      getDetailPanelContent={
        Form && !props.isDetails ? getDetailPanelContent : undefined
      }
      getDetailPanelHeight={Form ? getDetailPanelHeight : undefined}
      sx={{
        border: 'none',
        padding: '5px 15px',
        ...props.sx,
      }}
    />
  )
}
